
<template>
  <base-modal
    :title="title"
    :width="width"
    :height="height"
    :visible="visible"
    @cancel="open(false)"
  >
    <div slot="modalBody">
      <a-form :form="form">
        <a-form-item>
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-form layout="inline">
                <a-row :gutter="10">
                  <a-col :md="8" :sm="24">
                    <a-form-item label="名称">
                      <a-input placeholder="请输入名称" v-model="searchForm.userName" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="编号">
                      <a-input placeholder="请输入编号" v-model="searchForm.userNumber" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="部门">
                      <a-tree-select
                        v-model="searchForm.departmentname"
                        show-search
                        :filterTreeNode="filterTreeNode"
                        style="width:100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        placeholder="请选择部门"
                        allow-clear
                        tree-default-expand-all
                        :treeData="deptList"
                      ></a-tree-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="公司">
                      <a-tree-select
                        v-model="searchForm.subcompanyname"
                        show-search
                        :filterTreeNode="filterTreeNode"
                        style="width:100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        placeholder="请选择公司"
                        allow-clear
                        tree-default-expand-all
                        :treeData="companyList"
                      ></a-tree-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <span class="table-page-search-submitButtons">
                      <a-button type="primary" @click="search">查询</a-button>
                      <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </a-form>
          </div>
          <div>
            <a-table
              :rowSelection="rowSelection"
              :columns="table.columns"
              :dataSource="table.data"
              :loading="table.loading"
              :pagination="pagination"
              @change="handleTableChange"
              size="small"
              :scroll="{ y: 185 }"
            ></a-table>
          </div>
          <div style="border-top:1px solid #eee;">
            <span style="margin:0 8px 0 8px">已选人员:</span>
            <span v-if="hasSelected">
              <template v-for=" (item,index) in mList">
                <a-tag :key="item.userId" closable @close="log(index)">{{ item.userName }}</a-tag>
              </template>
            </span>
          </div>
        </a-form-item>
        <a-form-item style="text-align:center">
          <a-button type="primary" @click="handleSubmit" style="margin-right:10px;" :loading="iconLoading">保存</a-button>
          <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
        </a-form-item>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'

import { getUserChooseList, insertRoleUser } from '@/api/roleList'
import { formateTreeSelectData } from '@/utils/util'
import { getDeptTreeList } from '@/api/assetLedger'
import { getCompanyTree } from '@/api/organizationalStructure'

export default {
  name: 'EditGroup',
  mounted () {},
  components: {
    baseModal
  },
  data () {
    return {
      title: '选择人员',
      width: 800,
      height: 900,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'group' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 表格搜索框
      searchForm: {
        userName: '',
        userNumber: ''
      },
      // 所有搜索条件 用于表格接口传参
      searchModel: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [{
          title: '名称',
          dataIndex: 'userName',
        },
        {
          title: '编号',
          dataIndex: 'userNumber',
          width: '17%'
        },
        {
          title: '角色',
          dataIndex: 'roleNames',
          width: '16%'
        },
        {
          title: '部门名称',
          dataIndex: 'departmentname',
          width: '18%'
        },
        {
          title: '公司名称',
          dataIndex: 'subcompanyname',
          width: '24%'
        }],
        loading: false
      },
      selectedUserIds: [], // 选择的用户id
      loading: false,
      iconLoading: false,
      mList: [
        {
          userName: '',
          key: ''
        }
      ],

      deptList: [],
      companyList: []
    }
  },
  methods: {
    initSelectData () {
      // 获取公司树数据
      getDeptTreeList().then(res => {
        if (res && res.status === 0) {
          const loop = data => {
            for (let i = 0; i < data.length; i++) {
              // do
              data[i].name = data[i].subcompanydesc
              data[i].key = data[i].id + '_' + data[i].subcompanycode + ' && ' + data[i].name
              if (data[i].children.length) {
                loop(data[i].children)
              }
            }
          }
          loop(res.data)
          const data = { children: res.data, name: '公司' }
          const formateModel = formateTreeSelectData(data, 'name', 'key')
          this.companyList = formateModel.children
        }
      })
      // 获取使用部门数据
      getCompanyTree().then(res => {
        if (res && res.status === 0) {
          const loop = data => {
            for (let i = 0; i < data.length; i++) {
              // do
              data[i].name = data[i].subcompanyname
              data[i].key = data[i].id + '_' + data[i].type + ' && ' + data[i].name
              if (data[i].children.length) {
                loop(data[i].children)
              }
            }
          }
          loop(res.data)
          const data = { children: res.data, name: '部门' }
          const formateModel = formateTreeSelectData(data, 'name', 'key')
          this.deptList = formateModel.children
        }
      })
    },
    // 打开or关闭
    open (flag) {
      this.formClear()
      this.title = `【${this.roleName}】添加人员`
      this.pagination.current = 1
      this.visible = flag
      if (flag) {
        this.initSelectData()
        this.inUserData()
      }
    },
    inUserData () {
      const params = {
        roleId: this.roleId,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        userName: this.searchForm.userName || '',
        userNumber: this.searchForm.userNumber || '',
        departmentname: this.searchForm.departmentname ? this.searchForm.departmentname.split(' && ')[1] : '',
        subcompanyname: this.searchForm.subcompanyname ? this.searchForm.subcompanyname.split(' && ')[1] : ''
      }
      getUserChooseList(params).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list.map(item => {
            delete item.children
            return {
              key: item.userId,
              ...item
            }
          })

          this.pagination.total = res.data.total
        }
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.inUserData()
    },
    // 点击查询按钮
    search () {
      const { searchForm } = this
      if (searchForm.userName) {
        searchForm.userName = searchForm.userName.trim()
      }
      if (searchForm.userNumber) {
        searchForm.userNumber = searchForm.userNumber.trim()
      }
      this.inUserData()
    },
    // 点击复位按钮
    clearSearch () {
      this.searchForm = { roleId: this.roleId }
      this.pagination.current = 1
      this.inUserData()
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          if (this.selectedUserIds.length === 0) {
            this.$message.error('请先选择要添加的人员！')
            return
          }
          const params = {
            roleId: this.roleId,
            userIds: this.selectedUserIds.toString()
          }
          this.iconLoading = true
          insertRoleUser(params).then(res => {
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.error(res.info.message)
            }
            this.iconLoading = false
          }).catch(() => {
            this.iconLoading = false
          })
        }
      })
    },
    // 清空表单
    formClear () {
      this.searchForm = {}
      this.pagination.current = 1
      // this.clearSearch()
      this.selectedUserIds = []
      this.mList = []
    },
    cancel () {
      this.open(false)
      this.formClear()
    },
    // 关闭已选人员
    log (index) {
      this.mList.splice(index, 1)
      const userIds = []

      this.mList.map(item => {
        userIds.push(item.userId)
        return item
      })
      this.selectedUserIds = userIds
    },
    filterTreeNode (inputValue, treeNode) {
      return treeNode.componentOptions.propsData.dataRef.name.indexOf(inputValue.toLowerCase()) > -1
    }
  },
  computed: {
    roleId () {
      return this.$store.state.role.roleId
    },
    roleName () {
      return this.$store.state.role.roleName
    },
    hasSelected () {
      return this.selectedUserIds.length > 0
    },
    rowSelection () {
      return {
        selectedRowKeys: this.selectedUserIds,
        onChange: (selectedUserIds, selectedRows) => {
          for (const i in selectedUserIds) {
            if (this.selectedUserIds.indexOf(selectedUserIds[i]) === -1) {
              this.selectedUserIds.push(selectedUserIds[i])
            }
          }
        },
        onSelect: (record, selected, selectedRows) => {
          const mListUserIds = this.mList.map(item => {
            return item.userId
          })
          const userId = record.userId
          if (selected === true) {
            if (this.selectedUserIds.indexOf(userId) === -1) {
              this.selectedUserIds.push(userId)
            }
            if (mListUserIds.indexOf(userId) === -1) {
              this.mList.push({ userName: record.userName, userId: record.userId })
            }
          } else {
            console.log(userId)
            const index = this.selectedUserIds.indexOf(userId)
            index != -1 && this.selectedUserIds.splice(index, 1)
            // 获取mList
            this.mList = this.mList.filter(item => {
              return this.selectedUserIds.indexOf(item.userId) > -1 ? item : 0
            })
          }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          const mListUserIds = this.mList.map(item => {
            return item.userId
          })
          if (selected === true) {
            for (const i in changeRows) {
              if (this.selectedUserIds.indexOf(changeRows[i].userId) === -1) {
                this.selectedUserIds.push(changeRows[i].userId)
              }
              if (mListUserIds.indexOf(changeRows[i].userId) === -1) {
                this.mList.push({ userName: changeRows[i].userName, userId: changeRows[i].userId })
              }
            }
          } else {
            for (const j in changeRows) {
              const userId = changeRows[j].userId
              const index = this.selectedUserIds.indexOf(userId)
              index !== -1 && this.selectedUserIds.splice(index, 1)
              // 获取mList
              this.mList = this.mList.filter(item => {
                return this.selectedUserIds.indexOf(item.userId) > -1 ? item : 0
              })
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
